// DS i3.43
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const CreateFolder: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 3C3.33137 3 2.01031 4.34396 2.01 5.99942L2 16C2 17.6623 3.33772 19 5 19H10.5C11.0523 19 11.5 18.5523 11.5 18C11.5 17.4477 11.0523 17 10.5 17H5C4.44243 17 4.00023 16.5575 4 16L4.01 6C4.01 5.43573 4.44882 5 5 5H9.58579L11.5858 7H19C19.5577 7 20 7.44228 20 8V11C20 11.5523 20.4477 12 21 12C21.5523 12 22 11.5523 22 11V8C22 6.33772 20.6623 5 19 5H12.4142L10.4142 3H5ZM19 14C19 13.4477 18.5523 13 18 13C17.4477 13 17 13.4477 17 14V16H15C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18H17V20C17 20.5523 17.4477 21 18 21C18.5523 21 19 20.5523 19 20V18H21C21.5523 18 22 17.5523 22 17C22 16.4477 21.5523 16 21 16H19V14Z" />
    </svg>
  </IconWrap>
);
CreateFolder.displayName = 'CreateFolder';

export default CreateFolder;
